(function () {
  'use strict';

  function initDesktopNavigation() {
    var navigations = document.querySelectorAll(
      '.bedz-global-nav:not(.bedz-global-nav--compact)'
    );

    if (!navigations.length) {
      return;
    }

    Array.prototype.forEach.call(navigations, function (navigation) {
      var disclosures = Array.prototype.slice.call(
        navigation.querySelectorAll('.bedz-global-nav__disclosure')
      );
     
      function closeAll(exceptDisclosure) {
        disclosures.forEach(function (disclosure) {
          if (disclosure !== exceptDisclosure) {
            disclosure.removeAttribute('open');
          }
        });
      }

      function openDisclosure(disclosure) {
        closeAll(disclosure);
        disclosure.setAttribute('open', '');
      }

      disclosures.forEach(function (disclosure) {
        disclosure.addEventListener('toggle', function () {
          if (disclosure.open) {
            closeAll(disclosure);
          }
        });

        var trigger = disclosure.querySelector('.bedz-global-nav__trigger');

if (trigger) {
  trigger.addEventListener('click', function (event) {
    event.preventDefault();

    var wasOpen = disclosure.open;

    closeAll();

    if (!wasOpen) {
      disclosure.setAttribute('open', '');
    }
  });
}

        /* Desktop mouse users: reveal the dropdown without a click. */
disclosure.addEventListener('mouseenter', function () {
  openDisclosure(disclosure);
});

disclosure.addEventListener('mouseleave', function () {
  if (!disclosure.contains(document.activeElement)) {
    disclosure.removeAttribute('open');
  }
});
        /*
         * Keyboard users: focusing the summary opens the disclosure and
         * :focus-within keeps its active visual state while tabbing links.
         */
        disclosure.addEventListener('focusin', function (event) {
  if (event.target !== trigger) {
    openDisclosure(disclosure);
  }
});

        disclosure.addEventListener('focusout', function () {
          window.setTimeout(function () {
          if (
  !disclosure.contains(document.activeElement) &&
  !disclosure.matches(':hover')
) {
  disclosure.removeAttribute('open');
}  
          }, 0);
        });
      });

      document.addEventListener('click', function (event) {
        if (!navigation.contains(event.target)) {
          closeAll();
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') {
          return;
        }

        var openDisclosure = navigation.querySelector(
          '.bedz-global-nav__disclosure[open]'
        );

        if (!openDisclosure) {
          return;
        }

        var trigger = openDisclosure.querySelector(
          '.bedz-global-nav__trigger'
        );

        openDisclosure.removeAttribute('open');

        if (trigger) {
          trigger.focus();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initDesktopNavigation
    );
  } else {
    initDesktopNavigation();
  }
})();
